import { collection, doc, getFirestore, addDoc, Timestamp } from 'firebase/firestore';
import React, { useState } from 'react';
import PrimaryButton from '../components/buttons/PrimaryButton';
import Input from '../components/inputs/Input';
import { app } from '../firebase'; // Importez votre configuration Firebase
import { isCoownership, isProvider, useUser } from '../contexts/UserContext';
import FileInput from '../components/inputs/FileInput';
import { handleUpload } from '../librairies/FirebaseStorage';
import TextareaInput from '../components/inputs/TextareaInput';
import CheckboxInput from '../components/inputs/CheckboxInput';

const db = getFirestore(app);

function AddBillboard({onClose}) {

  //contexte de l'utilisateur connecté
  const user = useUser();

  const [loader, setLoader] = useState(false);
  const [error, setError] = useState("");
  
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [filename, setFilename] = useState(null);
  const [fileObject, setFileObject] = useState(null);
  const [typeFile, setTypeFile] = useState(null);
  const [infiniteBillboard, setInfiniteBillboard] = useState(false); //si on souhaite créer un affichage sans durée limite de temps

  const [errors, setErrors] = useState({
    title: '',
    description: '',
    file: ''
  });

  const resetState = () => {
    setError("");
    setTitle("");
    setDescription("");
  }

  /**
   * On crée le document billboard
   * @param {*} fileUrl 
   */
  const createDoc = async (fileUrl) => {
    //on envoie les données sur firestore 
    const billboardCollection = collection(db, user.user.userData.lastCoownershipLoaded.path+"/billboard");

    try{
      await addDoc(billboardCollection, {
        title: title,
        description:description,
        dateSave: Timestamp.fromDate(new Date()), 
        firstnameCreator: isProvider(user.user) ? "le prestataire "+user.user.userData.company : "le gestionnaire", 
        lastnameCreator: "", 
        status: "accepted",
        noTimeLimit: infiniteBillboard,
        idCreator: doc(db, 'users/' + user.user.user.uid),
        typeMedia: typeFile, 
        linkMedia: fileUrl,
      });
    } catch(err){
      setError("Une erreur est survenue, impossible d'ajouter l'affichage");
    }
  }

  const handleSubmit = async (e)  => {
    e.preventDefault();
    console.log("submit billboard");
    
    // Validation des champs
    const newErrors = {};

    if (!title) {
      newErrors.title = "Le titre est requis.";
    }


    if (Object.keys(newErrors).length === 0) {
      console.log("Données du formulaire valides.");

      try{
        setLoader(true);
        
        if(typeFile !== null && fileObject !== null){
          //un fichier souhaite être inséré
          try{
            let fileUrl = await handleUpload("billboard/", fileObject);

            createDoc(fileUrl);
            
          } catch (err){
            console.log(err);
            setError("Une erreur est survenue, impossible d'ajouter l'affichage");
            setLoader(false);
            return; 
          }
        }else{
          createDoc(null); 
        }

        setLoader(false);
        //on remet tous les states par défaut
        resetState(); 

        //on close la popup
        onClose(); 

      } catch(err){
        console.log(err)
        setError("Une erreur est survenue, impossible d'ajouter l'affichage");
        setLoader(false);
      }
    } else {
      // Afficher les erreurs
      setErrors(newErrors);
    }
  };

  
  /**
   * Modification de l'image de la copropriété
   * @param {*} e 
   */
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      console.log(file);

      if(file.type === "application/pdf"){
        setTypeFile("pdf"); 
      }else{
        setTypeFile("image"); 
      }

      // Vous pouvez effectuer des opérations supplémentaires ici, comme la validation du type de fichier
      setFilename(file.type === "application/pdf" ? file.name : URL.createObjectURL(file));
      setFileObject(file); 
    }
  };


  return (
    <div id="authentication-modal" tabindex="-1" aria-hidden="true" className="mx-auto w-full fixed inset-0 flex items-center justify-center overflow-auto">
      <div className="relative w-full max-w-md max-h-full">
        <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <button type="button" onClick={onClose} className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white" data-modal-hide="authentication-modal">
            <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
            </svg>
            <span className="sr-only">Close modal</span>
          </button>
          <div className="px-6 py-6 lg:px-8">
            <h3 className="mb-4 text-xl font-medium text-gray-900 dark:text-white">Ajouter un affichage</h3>

            <form onSubmit={handleSubmit}>
              <div className='mb-6'>
                <div className='border-b border-gray mt-0.5 mb-2'></div>
                  <Input id={"title"} label={"Titre"} type={"text"} name={"title"} value={title} onChange={(event) => setTitle(event.target.value)} error={errors.title} />
                  <TextareaInput id={"description"} label={"Description"} name={"description"} value={description} onChange={(event) => setDescription(event.target.value)} error={errors.description} required={false} />
                  <FileInput id={"affichage"} name={"affichage"} label={"Image ou PDF"} file={filename} onChange={handleFileChange} error={errors.file} fileAccepted={"image/*,application/pdf"} type={typeFile} />
                  {isCoownership(user.user) ? (
                    <CheckboxInput id={"infinite"} name={"infinite"} label={"Affichage sans durée limitée"} checked={infiniteBillboard} onChange={() => setInfiniteBillboard(!infiniteBillboard)} />
                  ) : null}
                </div>

                <div className="text-center">
                  <PrimaryButton type={"submit"} value={"Ajouter"} loading={loader} />
                </div>

                {error !== "" ? (
                  <p className='justify-center flex my-1 text-red-500'>{error}</p>
                ) : null}
            </form>
          </div>
        </div>
      </div>
    </div> 
  );
}

export default AddBillboard;